import React from "react";
import BrtxLinkCard from "../../componets/BrtxLinkCard";
import { Row} from "react-bootstrap";
import {
  FaBuilding,
  FaDatabase,
  FaMoneyBillAlt,
  FaRegPlusSquare
} from "react-icons/fa";
class Repair extends React.Component {
  state = {
    items: [
      {
        title: "Databáze opravy",
        subtitle: "Vyhledá stav Vaší opravy v našem systému.",
        link: "/repair/database",
        icon: <FaDatabase className="c-white" />,
      },
      {
        title: "Ceník nezáručních oprav",
        subtitle:
          "Aktuální ceník nezáručních oprav. Pokud nenaleznete hledaný ceník můžete zaslat dotaz na mobil@britex.cz",
        link: "/repair/priceList",
        icon: <FaMoneyBillAlt className="c-white" />,
      },
      {
        title: "Založit požadavek na opravu",
        subtitle:
          "Jedná-li se o záruční opravu je nutno dodat zařízení s kompletním příslušenstvím!",
        link: "/repair/createRequest",
        icon: <FaRegPlusSquare className="c-white" />,
      },
    ],
  };
  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaBuilding className="c-placeholder c-green" />,
      Title: "Opravy",
      SubTitle:
        "Založení servisního požadavku, sledování stavu opravy, ceníky apod...",
    });
  }

  render() {
    return (
      <>
        <Row className="d-flex mt-4">
          {this.state.items.map((i, idx) => (
            <BrtxLinkCard {...this.props} {...i} idx={idx} />
          ))}
        </Row>
      </>
    );
  }
}

export default Repair;
